import { typeaheadIsOpenAtom } from "@mirage/mosaics/SearchBarWithTypeahead/atoms";
import { EnvironmentProvider } from "@mirage/service-environment-context/environmentProvider";
import { getIsLauncher } from "@mirage/service-experimentation/useDualMode";
import { isEsvConfig } from "@mirage/shared/util/esv";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { OmniboxErrorBoundary } from "./components/OmniboxErrorBoundary";
import { PersistedOmnibox } from "./withPersistedOmniboxSurface";

export const EmbedLauncherPage: React.FC = () => {
  const setIsTypeaheadOpen = useSetAtom(typeaheadIsOpenAtom);

  // Autoset typeahead to open for embed launcher page
  useEffect(() => {
    if (isEsvConfig() && getIsLauncher()) {
      setIsTypeaheadOpen(true);
    }
  }, [setIsTypeaheadOpen, window.IS_LAUNCHER, isEsvConfig]);

  return (
    <EnvironmentProvider>
      <OmniboxErrorBoundary>
        <PersistedOmnibox shouldMemoize={true} />
      </OmniboxErrorBoundary>
    </EnvironmentProvider>
  );
};
